"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minimalPromotion = exports.MathUtil = exports.PromotionService = exports.Bundle = exports.currency = void 0;
var get_1 = __importDefault(require("lodash/get"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var omit_1 = __importDefault(require("lodash/omit"));
var unionBy_1 = __importDefault(require("lodash/unionBy"));
var pickBy_1 = __importDefault(require("lodash/pickBy"));
var currency_js_1 = __importDefault(require("currency.js"));
var Constants = __importStar(require("./constants"));
var getBundlePromoValue_1 = require("./getBundlePromoValue");
var currencyOpts = { precision: 2 };
var currency = function (value, options) { return (0, currency_js_1.default)(value, options || currencyOpts); };
exports.currency = currency;
exports.Bundle = {
    hasPromo: function (bundle) { return (0, get_1.default)(bundle, 'promotion.value', 0) > 0; },
    priceTotal: function (bundles) {
        return bundles.reduce(function (total, bundle) { return total.add(bundle.finalPrice); }, (0, exports.currency)(0)).value;
    },
    discountTotal: function (bundles, promotion) {
        return bundles.reduce(function (total, bundle) { return total.add((0, getBundlePromoValue_1.getBundlePromoValue)(bundle.finalPrice, promotion)); }, (0, exports.currency)(0)).value;
    },
    hasDiscountedMealDeal: function (bundle) { return !!(0, get_1.default)(bundle, 'deal.promotion', false); },
    mergeAndSort: function (processedBundles, originalList) {
        return (0, sortBy_1.default)((0, unionBy_1.default)(processedBundles, originalList, Constants.SORT_KEY), [Constants.SORT_KEY]).map(function (bundle) { return (0, omit_1.default)(bundle, Constants.SORT_KEY); });
    },
    hasMealDeal: function (bundle) { return !!(0, get_1.default)(bundle, 'deal'); },
    getMostExpensive: function (basket) { return (0, sortBy_1.default)(basket, 'finalPrice', 'asc').reverse().shift(); },
};
exports.PromotionService = {
    isOrderLevel: function (promo) { return promo.appliesTo === Constants.PromoAppliesTo.Order; },
    isFixed: function (promo) { return promo.type === Constants.promoTypes.FIXED; },
};
exports.MathUtil = {
    floor: function (value, decimals) { return Number(Math.floor(value + 'e' + decimals) + 'e-' + decimals); },
    proportion: function (value, total, distributedItem) {
        if (total === distributedItem)
            return value;
        return (0, exports.currency)(value, { precision: 20 }).divide(total).multiply(distributedItem).value;
    },
};
function minimalPromotion(fullPromotion) {
    var whitelistedProps = [
        'type',
        'value',
        'maxAmount',
        'name',
        'uuid',
        'loyaltyPoints',
        'providerPromotion',
        'appliesTo',
    ];
    return (0, pickBy_1.default)(fullPromotion, function (value, prop) { return whitelistedProps.includes(prop); });
}
exports.minimalPromotion = minimalPromotion;
